import React from "react";

/**
 * Empty-state block matching the QuantativeList chrome — chart glyph,
 * "No Data Found" heading, subdued help line, optional "Clear all
 * filters" button. Renders as a centred flex column so callers can drop
 * it inside a full-width table cell (with `padding: 0`) and have it
 * visually fill the body.
 */
const AssessmentEmptyState = ({
  icon = "📊",
  title = "No Data Found",
  message = "Try adjusting the filters or search term.",
  hasFilters = false,
  onClearFilters,
}) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "68px 24px",
      gap: 10,
    }}
  >
    <span style={{ fontSize: 40, opacity: 0.35 }}>{icon}</span>
    <div
      style={{
        fontWeight: 700,
        fontSize: 14,
        color: "var(--ink-2)",
        fontFamily: "var(--font-sans)",
      }}
    >
      {title}
    </div>
    <div
      style={{
        fontSize: 12.5,
        color: "var(--ink-4)",
        textAlign: "center",
        maxWidth: 360,
      }}
    >
      {message}
    </div>
    {hasFilters && onClearFilters ? (
      <button
        type="button"
        className="kpi-btn-secondary"
        onClick={onClearFilters}
        style={{ marginTop: 8 }}
      >
        Clear all filters
      </button>
    ) : null}
  </div>
);

export default AssessmentEmptyState;
